import React from "react";
import Grid from "@material-ui/core/Grid";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    padding: "0 20px",
    marginTop: (props) => (props.align === "row" ? "0" : "60px"),
  },
  legendList: {
    listStyleType: "none",
    padding: 0,
    display: (props) => (props.align === "row" ? "flex" : "block"),
    alignItems: "center",
    justifyContent: "center",
  },
  legendItem: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    marginRight: (props) => (props.align === "row" ? "10px" : "0"),
    margin: (props) => (props.align === "row" ? "0 10px" : "25px 10px"),
  },
  legendAmount: {
    float: "right",
    color: "#505050",
    fontSize: "1rem",
    fontWeight: 500,
    display: (props) => (props.align === "row" ? "none" : "inline-block"),
  },
  legendText: {
    color: "#757575",
    fontSize: "1rem",
  },
  legendColor: {
    minWidth: "31px",
    minHeight: "14px",
    display: "inline-block",
    marginRight: (props) => (props.align === "row" ? "8px" : "16.5px"),
  },
}));

const CardLegend = (props) => {
  const classes = useStyles(props);
  const lg = props.align === "row" ? 10 : 6;
  return (
    <Grid container justify="center" style={{ display: "block" }}>
      <Grid item xs={12} sm={10} md={6} lg={lg} style={{ margin: "0 auto" }}>
        <div className={classes.legendContainer}>
          <ul className={classes.legendList}>
            {props.options
              ? props.options.map((option, index) => (
                  <li className={classes.legendItem} key={index}>
                    <span
                      className={classes.legendColor}
                      style={{
                        backgroundColor: option.color,
                        border: `1px solid ${option.border} `,
                      }}
                    ></span>
                    <span className={classes.legendText}>{option.legend}</span>
                    {option.amount ? (
                      <span className={classes.legendAmount}>
                        {option.amount}
                      </span>
                    ) : null}
                  </li>
                ))
              : null}
          </ul>
        </div>
      </Grid>
    </Grid>
  );
};

export default CardLegend;
